import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useQuery({ queryKey: ["me"], queryFn: api.me });
  if (isLoading) return <div className="container py-12 text-center">בודק הרשאות…</div>;
  if (!data?.admin) return <Navigate to="/admin/login" replace />;
  return <>{children}</>;
}
